<div class="keyboard-audio">
  @switch (stateType$()) {
    @case (aIChatType.Recorder) {
      <div class="keyboard-audio__recorder">
        <div class="keyboard-audio__recorder-button">
          <empathy-viewer-icon-button
            [icon]="faMicrophoneReg"
            [style]="'stroked'"
            [size]="'large'"
            [testId]="'start-recording'"
            (clicked)="onEnableStartRecordingLayout()"
          ></empathy-viewer-icon-button>
        </div>

        <empathy-viewer-icon-button
          [icon]="faKeyboard"
          [testId]="'switch-to-keyboard'"
          (clicked)="stateType$.set(aIChatType.Keyboard)"
        ></empathy-viewer-icon-button>
      </div>
    }
    @case (aIChatType.Recording) {
      @if (transcriptionFailed$()) {
        <div class="keyboard-audio__recording__retry">
          <div class="keyboard-audio__recording__retry-button">
            <empathy-viewer-icon-button
              [icon]="faRepeat"
              [tooltip]="'Try again'"
              [testId]="'retry-audio'"
              (clicked)="onResendAudio()"
            ></empathy-viewer-icon-button>
          </div>

          <empathy-viewer-icon-button
            [icon]="faClose"
            [tooltip]="'Dismiss Audio'"
            [testId]="'dismiss-audio'"
            (clicked)="onDismiss()"
          ></empathy-viewer-icon-button>
        </div>
      } @else if (!processing$()) {
        <div class="keyboard-audio__recording">
          <empathy-audio-recorder
            [settings]="audioSettings"
            (completeRecordingEvent)="onAnswerAudio($event)"
            (abortRecordingEvent)="stateType$.set(aIChatType.Recorder)"
            (errorEvent)="onAudioRecorderError()"
            (processing)="processing.emit($event)"
          ></empathy-audio-recorder>
        </div>
      }
    }
    @case (aIChatType.Keyboard) {
      <div class="keyboard-audio__keyboard">
        <div class="question-form__input">
          <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'" class="eiq-survey-textarea">
            <textarea
              matInput
              surveyAutoFocus
              autocomplete="off"
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="3"
              [formControl]="answerCtrl"
              placeholder="Type answer here"
              (keydown.enter)="$event.preventDefault()"
              (keyup.enter)="onAnswer()"
            ></textarea>
          </mat-form-field>
        </div>

        @if (userTyped$() || !allowVoiceResponses) {
          <empathy-viewer-icon-button [icon]="faPaperPlaneTop" [size]="'large'" [testId]="'send-answer'" (clicked)="onAnswer()"></empathy-viewer-icon-button>
        } @else {
          <empathy-viewer-icon-button
            [icon]="faMicrophone"
            [size]="'large'"
            [testId]="'start-recording'"
            (clicked)="stateType$.set(aIChatType.Recorder)"
          ></empathy-viewer-icon-button>
        }
      </div>
    }
  }
</div>
